const localStorageKey = 'selectedMediationMetricSet';

const saveSelectedMetricSet = (key, data) => localStorage.setItem(localStorageKey + key, JSON.stringify(data));

const getDataFromLocalStorage = async (key) => {
    const metricSetData = localStorage.getItem(localStorageKey + key);

    if (!metricSetData) return 0;

    const parsed = Number.parseInt(metricSetData, 10);
    if (!Number.isNaN(parsed)) {
        return parsed;
    }
    return 0;
};

export default {
    saveSelectedMetricSet,
    getDataFromLocalStorage
};
